
import Search from '@/components/home/search.vue'
import Banner from '@/components/home/banner.vue'
import Advert from '@/components/home/advert.vue'
import FlashSale from '@/components/home/seckill.vue';
import HotCategories from '@/components/home/popular-categories.vue'
import IconDesign from '@/components/icon-design/icon-design.vue'
import { reactive, inject, ref, toRefs} from 'vue';
import { Base64 } from 'js-base64'

export default {
   components: {
    Search,
    Banner,
    Advert,
    IconDesign,
    FlashSale,
    HotCategories
  },
  props: {},
  setup(props: object){
      const $http: any = inject('$http')
      const $store: any = inject('$store')
      
      let item_datas = ref()
      const back_height_fn = (data_arr: Array<string>): void => {
          let h: number = document.body.scrollHeight;
          let back_height: number = 0
          window.parent.postMessage(data_arr[0] + '|' + h, "*");
          setTimeout(() =>{
            back_height_fn(data_arr);
          }, 1000)
      }

      let _this = this
      window.addEventListener('message',function(event){
          if(typeof(event.data) !== 'string') return false;
          let data_arr: Array<string> = event.data.split('|')
          let datas_json_str: string = data_arr[1]
          let datas_json: any =  JSON.parse(Base64.decode(datas_json_str))
          let arr_datas = []

          for (var i in datas_json) {
            let key = Object.getOwnPropertyNames(datas_json[i])[0]
            let value = datas_json[i][key]
  
            let tmpData = Object.assign({}, {floor_name: key}, value)
            arr_datas.push(tmpData)
          }
          item_datas.value = arr_datas
          back_height_fn(data_arr)
      }, false);
 
      return {
        item_datas
      }
    }
  
}
